import { frameAt, lookupTrack } from '@rcs/physics';
import type { SampledTrack } from '@rcs/track-geometry';

/** 1 両の位置と姿勢（前方 T・上方 U・右方 R）。 */
export interface CarPose {
  readonly position: readonly [number, number, number];
  readonly tangent: readonly [number, number, number];
  readonly up: readonly [number, number, number];
  readonly right: readonly [number, number, number];
}

/**
 * 編成の各車両の位置と姿勢（先頭の車両が最初）。
 *
 * 先頭の車両の中心が弧長 `s`、後ろの車両は、`pitch`（車両の長さ + 間隔）ずつ後ろの弧長に置く。
 * 1 両ずつ、その位置の軌道の接線・上方向に合わせるので、編成はカーブ・坂・ループに沿って曲がる。
 *
 * - 開いたコースの始点より後ろ（`s < 0`）は、始点の接線を後ろへ延長した直線の上に置く
 *   （駅を出る前の、まだ軌道に載っていない車両）
 * - 周回コースでは、始点をまたいで後ろの車両が前周の終わりに載る
 */
export function carPoses(
  track: SampledTrack,
  s: number,
  carCount: number,
  pitch: number,
): CarPose[] {
  const poses: CarPose[] = [];
  for (let i = 0; i < carCount; i += 1) {
    const arc = s - i * pitch;
    if (!track.closed && arc < 0) {
      const start = lookupTrack(track, 0);
      const frame = frameAt(start);
      poses.push({
        position: [
          start.position[0] + frame.tangent[0] * arc,
          start.position[1] + frame.tangent[1] * arc,
          start.position[2] + frame.tangent[2] * arc,
        ],
        ...frame,
      });
      continue;
    }
    const point = lookupTrack(track, arc);
    poses.push({ position: point.position, ...frameAt(point) });
  }
  return poses;
}
